import script from "./FormText.vue?vue&type=script&setup=true&lang=js"
export * from "./FormText.vue?vue&type=script&setup=true&lang=js"

import "./FormText.vue?vue&type=style&index=0&id=f0548130&lang=css"

const __exports__ = script;

export default __exports__